var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center justify-between gap-1 gap-y-4 lg:gap-y-0 lg:flex-row"},[_c('div',{staticClass:"lg:w-8/12"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.htmlTitle)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }